import * as React from 'react';

import type { OrganizationsContextValue } from '../../OrganizationsProvider.types';

import { OrganizationsContext } from '../../OrganizationsProvider';

export function useOrganizations(): OrganizationsContextValue {
  const context = React.useContext(OrganizationsContext);

  if (!context) {
    throw new Error(
      'useOrganizations must be used within OrganizationsProvider'
    );
  }

  return context;
}
